import { useEffect } from 'react';
import { apiRequest } from '@/lib/api';
import { useDataQuery } from '@/hooks/useDataQuery';

export interface AccountPackage {
  id: string | null; user_id: string; student_name: string; product_code: string;
  package_name: string; status: string; active: boolean; ends_at: string | null; device_limit: number | null; devices_unlimited?: boolean;
}
function useAccountPackages() {
  const query = useDataQuery(async () => (await apiRequest<{packages: AccountPackage[]}>('/account/packages')).packages);
  const reload=query.reload;
  useEffect(() => {
    const refresh = () => { if (document.visibilityState === 'visible') reload(); };
    window.addEventListener('focus', refresh);
    const timer = window.setInterval(refresh, 60000);
    return () => { window.removeEventListener('focus', refresh); window.clearInterval(timer); };
  }, [reload]);
  return query;
}
export default function AccountPackages() {
  const {data, loading, error, reload} = useAccountPackages();
  if (loading && !data) return <p role="status">Paket bilgisi yükleniyor…</p>;
  if (error) return <div role="alert">Paket bilgisi alınamadı. <button onClick={reload}>Yeniden dene</button></div>;
  return <section aria-label="Güncel paket bilgileri" className="grid gap-3 sm:grid-cols-2">
    {(data ?? []).map(p => <article key={p.user_id} className="rounded-2xl border border-primary-200 bg-primary-50 p-5">
      <p className="text-sm text-foreground-600">{p.student_name} · Güncel paket</p>
      <h2 className="mt-1 text-xl font-bold text-foreground-950">{p.package_name}</h2>
      <p className="mt-2 text-sm">{p.active ? 'Aktif' : p.status === 'expired' ? 'Süresi doldu' : 'Etkin değil'} · Sınırsız cihaz</p>
      <p className="text-sm">{p.ends_at ? `Bitiş: ${new Date(p.ends_at.replace(' ', 'T')).toLocaleDateString('tr-TR')}` : p.active ? 'Süresiz' : 'Etkin paket bulunmuyor'}</p>
    </article>)}
  </section>;
}
